const encodeString = (str: string): string => {
    return btoa(unescape(encodeURIComponent(str)));
};

const decodeString = (str: string): string => {
    return decodeURIComponent(escape(atob(str)));
};

export { encodeString, decodeString };
